import React, {Component} from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  FlatList,
  TextInput,
  Dimensions,
  Alert,
  Platform,
  Image,
  SafeAreaView,
} from 'react-native';
import edit_Icon from '../../assets/editIcon.png';
import deleteIcon from '../../assets/delete_icon.png';
import grayDeleteIcon from '../../assets/deleteGrayIcon.png';
import disableIcon from '../../assets/disableIcon.png';
import addIcon from '../../assets/add_icon.png';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import colors from '../../HelperClasses/AppColor';
import networkService from '../../Network/NetworkManager';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import PropTypes from 'prop-types';
import EmptyListUI from '../../Component/AppEmptyList';
import {getThumbnailImage} from '../../HelperClasses/SingletonClass';
import dropIcon from '../../assets/dropIcon.png';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import {checkUserRoleModule} from '../../HelperClasses/SingletonClass';
import {MODULEKEYS} from '../../Models/Enum';
import AppConstants from '../../Constants/AppConstants';
import {AppToast} from '../../HelperClasses/AppToast';
import {
  addMixpanelEvent,
  MixpanelEvent,
  MixPannelEnum,
} from '../../Models/MixPannelEnum';
import viewIcon from '../../assets/viewIcon.png';
import SaveButton from '../../Component/SaveButton';
import SecondryButton from '../../Component/SecondryButton';
import {RestrictedFeatureEnum} from '../../Models/RestrictedFeatureEnum';
import SidePanView from '../../Component/SidePanView';
import ImportCategories from './ImportCategories';
import {ToastContainer} from 'react-toastify';
import AddCategory from './AddCategory';
import Translations from './Translation';
import {TranslateEnum} from '../../Models/TranslateEnum';
import SubscribePlan from '../../Component/SubscribePlan';
import placeholder from '../../assets/pPlaceholder.png';
import BackBtnView from '../../Component/BackBtnView';
import {TypeEnum} from '../../Models/CommonEnum';
import ListingListUnderCategory from './ListingListUnderCategory';
import AccountsUnderCategory from './AccountsUnderCategory';
import SidePan from '../../Shared/SidePan';
import copyPasteIcon from '../../assets/copyPaste.png';
import GithubSlugger, {slug as slugChecker} from 'github-slugger';
import {withRouter} from '../../wrappers/withRouter';
import GenerateText from '../../utils/AI/GenerateText';
import {instructions} from '../../Constants/Instructions';
import {replacePlaceholders} from '../../utils/replacePlaceholders';
import {Gradient} from 'react-gradient';
import AppConfigStyleSheet from '../../StyleSheets/AppConfigStyleSheet';
import downArrow_Icon from '../../assets/downArrowIcon.png';
import CommonStyleSheet from '../../StyleSheets/CommonStyleSheet';
import whiteTick from '../../assets/whiteTick.png';

var pageNo = 1;
let PerPage = 20;
const APPURL = require('./../../Constants/URLConstants');

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;
let fixedWidth = AppConstants.mobileMaxWidth;
let itsMobileView = windowWidth < fixedWidth ? true : false;

const BATCH_SIZE = 100; // Adjust based on your needs

class CategoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropDown: false,
      selectedEntriesCount: 10,
      ListingArray: [],
      dateLoad: false,
      isEdit: false,
      selectedCategoryIndex: 0,
      haveData: false,
      updateUI: false,
      writeP: AppConstants.defaultWrite,
      readP: AppConstants.defaultWrite,
      deleteP: AppConstants.defaultDelete,
      showImportView: false,
      addCategoryBool: false,
      selectedData: '',
      translationBool: false,
      currentType: '',
      showListingsViews: false,
      showAccountsViews: false,
      totalRecords: 0,
      perPage: 20,
      stopPage: false,
    };

    this.handleRLDDChange = this.handleRLDDChange.bind(this);
  }
  static propTypes = {
    editBtn: PropTypes.func,
    addSubCatBtn: PropTypes.func,
    type: PropTypes.string,
    viewListingsBtn: PropTypes.func,
    fromRootScreen: PropTypes.bool,
    showBackBtn: PropTypes.bool,
    backBtnAction: PropTypes.func,
  };
  componentDidMount() {
    this.loadListingApi();
    this.checkModule();
    addMixpanelEvent(`${this.props.type} ${MixpanelEvent.viewCategory}`, {
      type: MixPannelEnum.listView,
    });
  }
  componentDidUpdate() {
    if (this.state.currentType.length != 0) {
      if (this.state.currentType != this.props.type) {
        this.setState({
          dateLoad: false,
          showImportView: false,
          translationBool: false,
          addCategoryBool: false,
        });
        this.loadListingApi();
      }
    }
  }
  checkModule = () => {
    let module =
      this.props.type == 'Listings'
        ? MODULEKEYS.LISTIINGSCATEGORY
        : MODULEKEYS.ACCOUNTSCATEGORY;

    checkUserRoleModule(module, res => {
      this.setState({readP: res[0], writeP: res[1], deleteP: res[2]});
    });
  };

  nextPreviousBtnAction(index) {
    if (index == 1) {
      if (!this.state.stopPage) {
        pageNo = pageNo + 1;
        this.loadListingApi();
      }
    } else {
      if (pageNo == 1) {
      } else {
        pageNo = pageNo - 1;
        this.loadListingApi();
      }
    }
    this.setState({updateUI: !this.state.updateUI});
  }

  showEntriesDropDown() {
    this.setState({showDropDown: !this.state.showDropDown});
  }
  didSelectPerPage = (item, index) => {
    this.state.perPage = item;
    this.setState({showDropDown: false});
    this.loadListingApi(item);
  };
  //MARK:-  APIS Method 
  loadListingApi = async (per_page = this.state.perPage) => {
    let path = this.props.type == 'Listings' ? 'listings' : 'accounts';
    this.state.currentType = this.props.type;

    try {
      const responseJson = await networkService.networkCall(
        APPURL.URLPaths.categories +
          path +
          '&page=' +
          pageNo +
          '&per_page=' +
          per_page,
        'get',
      );

      if (responseJson['status']) {
        this.state.totalRecords = responseJson['data']['total_records'];
        const categories = responseJson['data']['categories'];
        this.setState({
          haveData: this.state.ListingArray.length === 0,
          dateLoad: true,
        });

        await this.processCategoriesInBatches(categories);
        if (categories.length == 0) {
          pageNo = pageNo > 1 ? pageNo - 1 : 1;
          this.setState({stopPage: true});
        } else {
          this.setState({stopPage: false});
        }
      } else {
        this.alertView(responseJson);
        this.setState({dateLoad: true});
      }
    } catch (error) {
      console.error('Error loading categories:', error);
      this.setState({dateLoad: true});
    }
  };

  processCategoriesInBatches = async categories => {
    // Pre-process all categories into a flat map for O(1) lookups
    const categoryMap = new Map();
    const flattenedCategories = [];

    // First pass: Create map of all categories
    const processCategory = (category, parentPath = '') => {
      const currentPath = parentPath
        ? `${parentPath} -> ${category.name}`
        : category.name;

      const processedCategory = {
        ...category,
        hierarchyName: currentPath,
        deleteEnable: !category.sub_category?.length || category.parent !== 0,
        level: category.hierarchy?.[category.hierarchy.length - 1]?.level || 1,
      };

      categoryMap.set(category.id, processedCategory);
      flattenedCategories.push(processedCategory);

      if (category.sub_category?.length) {
        category.sub_category.forEach(subCat =>
          processCategory(subCat, currentPath),
        );
      }
    };

    // Process all categories into the map
    categories.forEach(category => processCategory(category));

    // Process in batches
    const totalCategories = flattenedCategories.length;
    const batchCount = Math.ceil(totalCategories / BATCH_SIZE);

    // Clear existing array
    this.setState({ListingArray: []});

    for (let i = 0; i < batchCount; i++) {
      const start = i * BATCH_SIZE;
      const end = Math.min(start + BATCH_SIZE, totalCategories);
      const batch = flattenedCategories.slice(start, end);

      // Process batch
      const processedBatch = batch.map(category => ({
        id: category.id,
        parent: category.parent,
        name: category.name,
        active: category.active,
        image_path: category.image_path,
        delete: category.deleteEnable,
        subCategory: category.name,
        order_by: category.order_by,
        slug: category.slug,
        description: category.description,
        meta_description: category.meta_description,
        meta_title: category.meta_title,
        type: category.type,
        hierarchyName: category.hierarchyName,
        level: category.level,
      }));

      // Update state with new batch
      await new Promise(resolve => {
        this.setState(
          prevState => ({
            ListingArray: [...prevState.ListingArray, ...processedBatch],
          }),
          resolve,
        );
      });

      // Optional: Add a small delay between batches to prevent UI blocking
      if (i < batchCount - 1) {
        await new Promise(resolve => setTimeout(resolve, 0));
      }
    }
  };

  deleteCategoryApi = async id => {
    this.setState({dateLoad: false});
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.addCategories + '/' + id,
      'delete',
    );
    this.setState({dateLoad: true});
    if (responseJson['status'] == true) {
      this.mixpanelInfo(true);
      this.loadListingApi();
      this.alertView('delete');
    } else {
      this.mixpanelInfo(false);
      this.alertView(responseJson);
    }
  };
  exportApi = async () => {
    let dict = {type: this.props.type == 'Listings' ? 'listings' : 'accounts'};
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.categoriesExport,
      'post',
      JSON.stringify(dict),
    );
    if (responseJson['status'] == true) {
      let downloadLink = responseJson['data']['download_url'];
      window.open(downloadLink);
    }
  };
  mixpanelInfo(resp) {
    let properties = {success: resp};
    addMixpanelEvent(
      `${this.props.type} ${MixpanelEvent.deleteCategory}`,
      properties,
    );
  }
  bulkAttributeAPI = async data => {
    var dict = [];
    var i = 1;
    for (let objc of data) {
      var doc = {
        order_by: i,
        id: objc['id'],
      };
      dict.push(doc);
      i++;
    }
    var path = APPURL.URLPaths.addCategories + APPURL.URLPaths.bulk;
    const responseJson = await networkService.networkCall(
      path,
      'PATCH',
      JSON.stringify({categories: dict}),
    );
    // console.log('category', responseJson);
    if (responseJson['status'] == true) {
    }
  };
  alertView(title) {
    if (Platform.OS === 'web') {
      AppToast(title);
    } else {
      Alert.alert(title);
    }
  }
  statusBtnAction = index => {
    if (Platform.OS === 'web') {
      alert(index);
    } else {
      Alert.alert(index);
    }
  };
  editButtonAction = index => {
    let id_Index = this.state.ListingArray.findIndex(x => x.id === index);

    this.setState({
      isEdit: true,
      selectedData: this.state.ListingArray[id_Index],
      addCategoryBool: !this.state.addCategoryBool,
    });
  };
  addCategoryBtnAction = index => {
    let id_Index = this.state.ListingArray.findIndex(x => x.id === index);

    if (this.props.type == 'Listings') {
      this.props.navigate('/add-listing-category');
    } else {
      this.setState({
        addCategoryBool: !this.state.addCategoryBool,
        isEdit: false,
        selectedData: this.state.ListingArray[id_Index],
      });
    }
  };
  viewListingsBtnAction = index => {
    let id_Index = this.state.ListingArray.findIndex(x => x.id === index);

    if (this.props.type == TypeEnum.listings) {
      this.setState({
        showListingsViews: !this.state.showListingsViews,
        selectedData: this.state.ListingArray[id_Index],
      });
    } else {
      this.setState({
        showAccountsViews: !this.state.showAccountsViews,
        selectedData: this.state.ListingArray[id_Index],
      });
    }
  };

  deleteCategoryAction = index => {
    // let id_Index = this.state.ListingArray.findIndex(x => x.id === index);
    // if (this.state.ListingArray[id_Index]['delete'] == true) {
    // console.log('index', index);
    if (Platform.OS === 'web') {
      const r = window.confirm(
        'Existing listings will not open in website or app, you will see an error.',
      );
      if (r == true) {
        this.deleteCategoryApi(index);
      }
    }
  };

  handleRLDDChange(reorderedItems) {
    this.state.ListingArray = reorderedItems;
    this.setState({updateUI: !this.state.updateUI});
    this.bulkAttributeAPI(reorderedItems);
  }
  exportBtnAction() {
    this.exportApi();
  }
  importBtnAction() {
    this.setState({showImportView: !this.state.showImportView});
  }
  checkRestriction() {
    let check = AppConstants.restrictedFeatureArray.includes(
      RestrictedFeatureEnum.bulkEditListings,
    );
    let check_access = AppConstants.accessControl?.[
      AppConstants.plan_name
    ]?.includes(RestrictedFeatureEnum.bulkOperations);
    return check || check_access;
  }
  addBtnAction() {
    if (this.props.type == 'Listings') {
      this.props.navigate('/add-listing-category');
    } else {
      this.setState({
        isEdit: false,
        addCategoryBool: !this.state.addCategoryBool,
        selectedData: '',
      });
    }
  }
  backBtnBtn() {
    this.setState({
      selectedData: '',
      addCategoryBool: false,
      isEdit: false,
    });
    this.loadListingApi();
  }
  /*  UI   */
  tableViewHeader = props => {
    return (
      <FlatList
        data={tableHeaderString}
        horizontal={true}
        renderItem={this.tableHeaderCell}
        extraData={this.state}
        showsVerticalScrollIndicator={false}
        scrollEnabled={false}
      />
    );
  };
  tableHeaderCell = ({item, index}) => {
    if (index == 0) {
      return (
        <View style={styles.tableViewTitleViewStyle}>
          <Text style={tableStyle.tableViewTitleStyle}>{item}</Text>
        </View>
      );
    } else {
      return (
        <View style={styles.firstTableViewTitleViewStyle}>
          <Text style={tableStyle.tableViewTitleStyle}>{item}</Text>
        </View>
      );
    }
  };
  columnDataView = props => {
    if (this.state.ListingArray.length == 0) {
      if (this.state.haveData) {
        return (
          <View style={{height: windowHeight / 2}}>
            <EmptyListUI showImage={true} />
          </View>
        );
      } else {
        return <View />;
      }
    } else {
      var views = [];
      for (let i = 0; i < this.state.ListingArray.length; i++) {
        let item = this.state.ListingArray[i];
        views.push(
          <FlatList
            data={[
              item['id'],
              item['id'],
              item['image_path'] || '',
              item['order_by'] || '',
              item['parent'] == '0' ? 'Yes' : 'No',
              item['active'] == true ? 'Active' : 'Inactive',
              item['id'],
              item['id'],
            ]}
            style={{backgroundColor: 'white'}}
            horizontal={true}
            renderItem={this.columnCell}
            extraData={this.state}
            showsVerticalScrollIndicator={false}
            scrollEnabled={true}
          />,
        );
      }
      return (
        <View style={{flexDirection: 'row', flex: 1}}>
          <View style={{display: this.state.writeP ? 'flex' : 'none'}}>
            <RLDD
              items={this.state.ListingArray}
              itemRenderer={this.renderDragDropView}
              onChange={this.handleRLDDChange}
            />
          </View>
          <View
            style={{display: !this.state.writeP ? 'flex' : 'none', width: 22}}
          />
          <View style={{flexDirection: 'column'}}>{views}</View>
        </View>
      );
    }
  };
  renderDragDropView = (item, index) => {
    return (
      <View>
        <FlatList
          data={[1]}
          style={{backgroundColor: 'white'}}
          horizontal={true}
          renderItem={this.renderDropdownCell}
          extraData={this.state}
          showsVerticalScrollIndicator={false}
          scrollEnabled={false}
        />
      </View>
    );
  };
  renderDropdownCell = ({item}) => {
    return (
      <View style={tableStyle.dragdropViewStyle}>
        <Image
          style={tableStyle.dragIconStyle}
          resizeMode="center"
          source={dropIcon}
        />
      </View>
    );
  };

  columnCell = ({item, index}) => {
    let id_Index = this.state.ListingArray.findIndex(x => x.id === item);
    if (index == 5) {
      return (
        <View style={styles.columnTitleViewStyle}>
          <Text
            style={
              item == 'Active'
                ? tableStyle.columnActiveBtnStyle
                : tableStyle.columnDeActiveBtnStyle
            }>
            {item}
          </Text>
        </View>
      );
    } else if (index == 4) {
      return (
        <View style={styles.columnTitleViewStyle}>
          <View style={{marginLeft: 0}}>
            <Text
              style={
                item == 'No'
                  ? tableStyle.columnDeActiveBtnStyle
                  : tableStyle.columnActiveBtnStyle
              }>
              {item}
            </Text>
          </View>
        </View>
      );
    } else if (index == 2) {
      let fileUrl = getThumbnailImage(item);
      return (
        <View style={styles.columnTitleViewStyle}>
          <View style={{marginLeft: 0}}>
            <Image
              style={tableStyle.itemImageViewStyle}
              source={item.length == 0 ? placeholder : fileUrl}
            />
          </View>
        </View>
      );
    } else if (index == 6) {
      return (
        <View style={styles.columnTitleViewStyle}>
          <View style={{flexDirection: 'row', marginRight: 20}}>
            {this.renderEditBtn(item)}
            <View style={{width: 10}} />
            <this.renderDeleteView item={item} />
            <View style={{width: 10}} />
            {this.renderAddCategoryBtn(item)}
            <View style={{width: 10}} />
            {this.renderViewListingBtn(item)}
          </View>
        </View>
      );
    } else if (index == 3) {
      return (
        <View style={styles.columnTitleViewStyle}>
          <View style={{marginLeft: 0}}>
            <Text style={tableStyle.categoryColumnViewTitleStyle}>{item}</Text>
          </View>
        </View>
      );
    } else if (index == 1) {
      return (
        <View style={styles.columnTitleViewStyle}>
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            <Text style={tableStyle.columnViewTitleStyle}>{item}</Text>
            <View style={{width: 10}} />
            <TouchableOpacity
              onPress={() => navigator.clipboard.writeText(`${item}`)}>
              <Image source={copyPasteIcon} style={{width: 15, height: 15}} />
            </TouchableOpacity>
          </View>
        </View>
      );
    } else if (index == 7) {
      let dict = this.state.ListingArray[id_Index];
      let path =
        dict['type'] === 'listings'
          ? `${AppConstants.domainKey}/lc/${
              dict?.slug
                ? dict?.slug
                : `${dict['id']}-${slugChecker(dict?.name)}`
            }`
          : undefined;

      return path ? (
        <View
          style={{
            width: '100%',
            justifyContent: 'flex-start',
            padding: 10,
            alignItems: 'center',
            flexDirection: 'row',
            backgroundColor: 'white',
          }}>
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            <TouchableOpacity onPress={() => window.open(path)}>
              <Text
                style={
                  (tableStyle.columnViewTitleStyle, {whiteSpace: 'nowrap'})
                }>
                {path}
              </Text>
            </TouchableOpacity>

            <View style={{width: 10}} />
            <TouchableOpacity
              onPress={() => navigator.clipboard.writeText(path)}>
              <Image source={copyPasteIcon} style={{width: 15, height: 15}} />
            </TouchableOpacity>
          </View>
        </View>
      ) : (
        <View style={styles.firstColumnStyle}>
          <Text style={tableStyle.categoryColumnViewTitleStyle}>N/A</Text>
        </View>
      );
    } else if (this.state.ListingArray[id_Index]['delete'] == true) {
      return (
        <View style={styles.firstColumnStyle}>
          <View>
            <Text style={tableStyle.categoryColumnViewTitleStyle}>
              {this.state.ListingArray[id_Index]['subCategory']}
            </Text>
            <Text style={tableStyle.cateSubTitle}>
              {this.state.ListingArray[id_Index]['hierarchyName']}
            </Text>
          </View>
        </View>
      );
    } else {
      return (
        <View style={styles.firstColumnStyle}>
          <Text style={tableStyle.categoryColumnViewTitleStyle}>
            {this.state.ListingArray[id_Index]['name']}
          </Text>
        </View>
      );
    }
  };
  renderEditBtn = item => {
    return (
      <TouchableOpacity
        disabled={!this.state.writeP}
        onPress={() => {
          this.editButtonAction(item);
        }}>
        <Image
          style={tableStyle.iconStyle}
          resizeMode="center"
          source={this.state.writeP ? edit_Icon : disableIcon}
        />
      </TouchableOpacity>
    );
  };
  renderAddCategoryBtn = item => {
    return (
      <TouchableOpacity
        disabled={!this.state.writeP}
        onPress={() => this.addCategoryBtnAction(item)}>
        <Image
          style={tableStyle.iconStyle}
          resizeMode="center"
          source={this.state.writeP ? addIcon : disableIcon}
        />
      </TouchableOpacity>
    );
  };
  renderViewListingBtn = item => {
    return (
      <TouchableOpacity
        disabled={!this.state.writeP}
        onPress={() => this.viewListingsBtnAction(item)}>
        <Image
          style={tableStyle.iconStyle}
          resizeMode="center"
          source={this.state.writeP ? viewIcon : viewIcon}
        />
      </TouchableOpacity>
    );
  };

  renderDeleteView = item => {
    let id = item['item'];
    let id_Index = this.state.ListingArray.findIndex(x => x.id === id);
    if (this.state.deleteP) {
      if (this.state.ListingArray[id_Index]['delete'] == true) {
        return (
          <TouchableOpacity onPress={() => this.deleteCategoryAction(id)}>
            <Image
              style={tableStyle.iconStyle}
              resizeMode="center"
              source={deleteIcon}
            />
          </TouchableOpacity>
        );
      } else {
        return (
          <View onPress={() => this.deleteCategoryAction(id)}>
            <Image
              style={tableStyle.iconStyle}
              resizeMode="center"
              source={grayDeleteIcon}
            />
          </View>
        );
      }
    } else {
      return (
        <View onPress={() => this.deleteCategoryAction(id)}>
          <Image
            style={tableStyle.iconStyle}
            resizeMode="center"
            source={disableIcon}
          />
        </View>
      );
    }
  };
  renderTranslateBtnView = () => {
    return (
      <View>
        <SecondryButton
          showBtn={true}
          btnTitle={'Translate'}
          deActiveBtnAction={() =>
            this.state.writeP && this.setState({showUpgrade: true})
          }
          btnAction={() =>
            this.setState({translationBool: !this.state.translationBool})
          }
          btnDeActive={!this.state.writeP}
        />
      </View>
    );
  };
  renderImportExportBtnView = ({id}) => {
    return (
      <View>
        <SecondryButton
          showBtn={true}
          btnDeActive={this.checkRestriction() || !this.state.writeP}
          btnTitle={id == 1 ? 'Import' : 'Export'}
          deActiveBtnAction={() =>
            this.state.writeP && this.setState({showUpgrade: true})
          }
          btnAction={() =>
            id == 1 ? this.importBtnAction() : this.exportBtnAction()
          }
        />
      </View>
    );
  };
  renderHeaderView = () => {
    const ins =
      this.props.type === 'Listings'
        ? instructions.listing_category
        : instructions.account_category;

    return (
      <View style={[tableStyle.headerViewstyle]}>
        <View style={tableStyle.headerTitleContainerViewStyle}>
          <View
            style={{
              display: this.props.showBackBtn ? 'flex' : 'none',
              marginRight: 16,
            }}>
            <TouchableOpacity
              style={[tableStyle.backBtnBackViewStyle, {marginLeft: 0}]}
              onPress={this.props.backBtnAction}>
              <BackBtnView />
            </TouchableOpacity>
          </View>
          <Text style={tableStyle.titleTextStyle}>Categories </Text>
          <GenerateText
            user_id={AppConstants.userId}
            system_instruction={ins.system}
            user_message={replacePlaceholders({
              template: ins.user,
              data: {
                expectations:
                  AppConstants?.tenant_metadata?.expectations ?? 'c2c',
              },
            })}
            type={'category_examples'}
          />
        </View>
        <View style={{flexDirection: 'row', marginTop: itsMobileView ? 5 : 0}}>
          <this.renderImportExportBtnView id={1} />
          <this.renderImportExportBtnView id={2} />
          <this.renderTranslateBtnView />
          <SaveButton
            saveBtn={() => this.addBtnAction()}
            saveBtnTitle={'Add Category'}
            btnDeActive={!this.state.writeP}
            showLock={true}
          />
        </View>
      </View>
    );
  };
  renderSidePanView = () => {
    if (this.state.showImportView) {
      return (
        <SidePanView
          dissmissView={() =>
            this.setState({showImportView: !this.state.showImportView})
          }
          showSidepanView={this.state.showImportView}
          title={'Import Categories'}
          customView={
            <View>
              <ToastContainer />
              <ImportCategories
                type={this.props.type}
                backBtnAction={() => this.backBtnBtn()}
              />
            </View>
          }
        />
      );
    } else {
      return <View />;
    }
  };
  renderMainListView = () => {
    return (
      <View style={tableStyle.containerMainView}>
        <ScrollView style={tableStyle.mainScrollViewStyle} horizontal={true}>
          <View>
            <View
              style={{
                height: 40,
                backgroundColor: colors.AppLightGreen,
                borderTopStartRadius: 5,
                borderTopEndRadius: 5,
                paddingLeft: 10,
              }}>
              <this.tableViewHeader />
            </View>
            <ScrollView style={{backgroundColor: 'white'}}>
              <this.columnDataView />
            </ScrollView>
          </View>
        </ScrollView>
      </View>
    );
  };
  renderUpgradePlanView = () => {
    return (
      <TouchableOpacity
        style={[
          tableStyle.passwordViewStyle,
          {display: this.state.showUpgrade ? 'flex' : 'none'},
        ]}
        onPress={() => this.setState({showUpgrade: false})}>
        <SubscribePlan upgrade={true} />
      </TouchableOpacity>
    );
  };

  gradientButtons = name => {
    if (this.state.totalRecords > PerPage) {
      if (this.state.ListingArray.length != 0 || pageNo > 1) {
        if (name['id'] == 2 && pageNo == 1) {
          return <View />;
        } else if (
          name['id'] == 1 &&
          this.state.ListingArray.length == 0 &&
          pageNo > 1
        ) {
          return <View />;
        }
        return (
          <View>
            <View style={tableStyle.grandientBGStyle}>
              <Gradient
                gradients={colors.GradientColors} // required
                property="background"
                gradientType={'linear'}
                duration={2333000}
                style={{
                  height: 30,
                  width: 100,
                  borderRadius: 3,
                  marginRight: 30,
                }}
                angle="0deg">
                <TouchableOpacity
                  style={tableStyle.nextPreviousViewStyle}
                  onPress={() => this.nextPreviousBtnAction(name['id'])}>
                  <Text style={{color: 'white'}}>{name['name']}</Text>
                </TouchableOpacity>
              </Gradient>
            </View>
          </View>
        );
      } else {
        return <View />;
      }
    } else {
      return <View />;
    }
  };

  entriesDropDown = props => {
    if (this.state.showDropDown == true) {
      return (
        <View style={tableStyle.perPageContainerViewStyle}>
          <View style={{height: 4}} />
          <FlatList
            data={['10', '20', '40', '60', '80', '100']}
            horizontal={false}
            renderItem={this.renderDropDown}
            extraData={this.state}
            showsVerticalScrollIndicator={false}
            scrollEnabled={true}
            keyExtractor={(item, index) => index + 989}
            key={'E'}
          />
        </View>
      );
    }
    return <View />;
  };
  renderDropDown = ({item, index}) => {
    return (
      <TouchableOpacity
        onPress={() => this.didSelectPerPage(item, index)}
        style={{margin: 3}}>
        <View
          style={[
            tableStyle.perPageDropDownViewStyle,
            {
              backgroundColor:
                item == this.state.perPage ? colors.BGBlueColor : '',
            },
          ]}>
          <Image
            source={whiteTick}
            style={{height: 16, width: item == this.state.perPage ? 16 : 0}}
          />
          <Text style={CommonStyleSheet.dropdownCellWhiteTextStyle}>
            {item}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };
  renderPerView = () => {
    return (
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          marginRight: 20,
        }}>
        <Text>Show rows</Text>
        <View style={{flexDirection: 'column', zIndex: 9999}}>
          <TouchableOpacity
            onPress={() => this.showEntriesDropDown()}
            style={tableStyle.perPagedropDownView}>
            <Text> {this.state.perPage} </Text>
            <Image
              style={
                this.state.showDropDown == true
                  ? AppConfigStyleSheet.upArraowIconStyle
                  : AppConfigStyleSheet.downArraowIconStyle
              }
              resizeMode="contain"
              source={downArrow_Icon}
            />
          </TouchableOpacity>
          <this.entriesDropDown />
        </View>
      </View>
    );
  };

  renderBottomView = () => {
    if (this.state.totalRecords > this.state.perPage) {
      return (
        <View style={tableStyle.bottomViewStyle}>
          <this.gradientButtons name={'Next'} id={1} />
          <this.gradientButtons name={'Previous'} id={2} />
          <this.renderPerView />
        </View>
      );
    } else {
      return <View />;
    }
  };

  render() {
    if (this.state.translationBool) {
      return (
        <View style={{flexDirection: 'column'}}>
          <ToastContainer />
          <Translations
            titleString={this.props.type}
            translationTitle={'Category'}
            translationRef={TranslateEnum.category}
            backBtnAction={() => this.setState({translationBool: false})}
          />
        </View>
      );
    } else if (this.state.showListingsViews) {
      return (
        <View style={{flexDirection: 'column'}}>
          <ListingListUnderCategory
            categoryData={this.state.selectedData}
            type={this.props.type}
            CID={this.state.selectedData['id']}
            backBtnAction={() => this.setState({showListingsViews: false})}
          />
        </View>
      );
    } else if (this.state.showAccountsViews) {
      return (
        <View style={{flexDirection: 'column'}}>
          <AccountsUnderCategory
            type={this.props.type}
            CID={this.state.selectedData['id']}
            categoryData={this.state.selectedData}
            backBtnAction={() => this.setState({showAccountsViews: false})}
          />
        </View>
      );
    } else {
      return (
        <SafeAreaView style={styles.Container}>
          <View style={{zIndex: 101}}>
            <this.renderSidePanView />
            <this.renderUpgradePlanView />
          </View>
          <View style={{zIndex: 1}}>
            <this.renderHeaderView />
            {this.state.readP && <this.renderMainListView />}
            {this.renderBottomView()}
            <Appload enable={this.state.dateLoad} />
          </View>
          <SidePan
            openSidepan={this.state.addCategoryBool}
            closeSipan={() =>
              this.setState({
                addCategoryBool: false,
                selectedData: '',
                isEdit: false,
              })
            }
            sidepan_width={windowWidth - 250}>
            {this.state.addCategoryBool && (
              <View style={{flexDirection: 'column'}}>
                <ToastContainer />
                <AddCategory
                  type={this.props.type}
                  isEdit={this.state.isEdit}
                  sidepanOpen={this.state.addCategoryBool}
                  categoryData={this.state.selectedData}
                  closeBtnAction={() => this.setState({addCategoryBool: false})}
                  backBtnAction={() => this.backBtnBtn()}
                />
              </View>
            )}
          </SidePan>
        </SafeAreaView>
      );
    }
    //}
  }
}
export default withRouter(CategoryList);

let constantWidth =
  windowWidth < fixedWidth ? windowWidth / 3 : windowWidth / 9.4;
let firstWidth = windowWidth / 5;
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: colors.AppLightGreen,
  },
  tableViewTitleViewStyle: {
    padding: 0,
    width: firstWidth,
    marginLeft: 25,
    height: 40,
  },
  firstTableViewTitleViewStyle: {
    padding: 0,
    width: constantWidth,
    height: 40,
  },
  columnTitleViewStyle: {
    width: constantWidth,
    borderBottomWidth: 1,
    borderBottomColor: colors.SimonGray,
    padding: 2,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    paddingLeft: 12,
  },
  firstColumnStyle: {
    width: firstWidth,
    borderBottomWidth: 1,
    borderBottomColor: colors.SimonGray,
    padding: 2,
    alignItems: 'center',
    flexDirection: 'row',
    paddingLeft: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

const tableHeaderString = [
  'Name',
  'Category ID',
  'Image',
  'Order',
  'Parent',
  'Active',
  'Action',
  'URL',
];
